import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-273a6772"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-overview" }
const _hoisted_2 = { class: "account-overview__container" }
const _hoisted_3 = { class: "account-overview__section" }
const _hoisted_4 = { class: "account-overview__title" }
const _hoisted_5 = {
  key: 0,
  class: "account-overview__subtitle"
}
const _hoisted_6 = { class: "account-overview__row" }
const _hoisted_7 = { class: "account-overview__label" }
const _hoisted_8 = { class: "account-overview__row" }
const _hoisted_9 = { class: "account-overview__label" }
const _hoisted_10 = { class: "account-overview__value" }
const _hoisted_11 = { class: "account-overview__row" }
const _hoisted_12 = { class: "account-overview__label" }
const _hoisted_13 = { class: "account-overview__value" }
const _hoisted_14 = { class: "account-overview__row" }
const _hoisted_15 = { class: "account-overview__label" }
const _hoisted_16 = { class: "account-overview__value" }
const _hoisted_17 = { class: "account-overview__section" }
const _hoisted_18 = { class: "account-overview__title" }
const _hoisted_19 = { class: "account-overview__row" }
const _hoisted_20 = { class: "account-overview__label" }
const _hoisted_21 = { class: "account-overview__value" }
const _hoisted_22 = { class: "account-overview__row" }
const _hoisted_23 = { class: "account-overview__label" }
const _hoisted_24 = { class: "account-overview__value" }
const _hoisted_25 = { class: "account-overview__row" }
const _hoisted_26 = { class: "account-overview__label" }
const _hoisted_27 = { class: "account-overview__value" }
const _hoisted_28 = { class: "account-overview__row" }
const _hoisted_29 = { class: "account-overview__label" }
const _hoisted_30 = { class: "account-overview__value" }

import { computed, onBeforeMount } from 'vue';
import { useI18n } from 'vue-i18n';

import { accountService } from '@exchange/libs/account/service/src';
import { authService } from '@exchange/libs/auth/service/src';
import { futuresService, marginService } from '@exchange/libs/futures/service/src';
import { ACCOUNT_RATIO_STATUS_THRESHOLD_LABELS, AccountRatioStatus } from '@exchange/libs/futures/service/src/lib/account-ratio';
import { useFutures } from '@exchange/libs/futures/ui/src/lib/useFutures';
import { subaccountsService } from '@exchange/libs/trading-accounts/service/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountOverview',
  setup(__props) {

const { t } = useI18n({ useScope: 'global' });

const { accountId } = accountService;
const { accountRatio, accountRatioStatus, balance: marginBalance, equity, maintenanceMargin } = marginService;
const { getAccountById } = subaccountsService;
const { getFuturesPositions: futuresPositions } = useFutures();

const account = computed(() => getAccountById(accountId.value));
const isAuthenticated = computed(() => authService.hasBeenAuthenticated);

// Computed values from futures positions
const accountData = computed(() => {
  const accountDataDefaults = {
    marginRatio: '-',
    marginRatioStatus: null,
    maintenanceMargin: maintenanceMargin.value,
    leverage: '-',
    positionValue: 0,
    equity: equity.value,
    availableMargin: marginBalance.value.available,
    lockedMargin: marginBalance.value.used,
    realisedPnL: 0,
  };

  if (!isAuthenticated.value || !account.value || !futuresPositions.value.length) {
    return accountDataDefaults;
  }

  const totalPositionValue = futuresPositions.value.reduce((sum, pos) => sum + Number(pos.open_position), 0);
  const totalRealisedPnL = futuresPositions.value.reduce((sum, pos) => sum + Number(pos.realised_pnl ?? 0), 0);
  const totalNotionalValue = futuresPositions.value.reduce((sum, pos) => sum + Math.abs(Number(pos.open_volume) * Number(pos.mark_price ?? 0)), 0);
  const combinedLeverage = equity.value > 0 ? totalNotionalValue / equity.value : 0;

  return {
    ...accountDataDefaults,
    marginRatio: accountRatio.value ? accountRatio.value.toFixed(2) : accountDataDefaults.marginRatio,
    marginRatioStatus: accountRatioStatus.value,
    leverage: `${combinedLeverage.toFixed(2)}x`,
    positionValue: totalPositionValue,
    realisedPnL: totalRealisedPnL,
  };
});

const getTooltip = (d: { message: string; html?: boolean }) => ({
  content: d.message,
  placement: 'top',
  html: d.html,
});

onBeforeMount(futuresService.getLeverage);

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _component_ot_lozenge = _resolveComponent("ot-lozenge")!
  const _component_ot_number_display = _resolveComponent("ot-number-display")!
  const _component_ot_module_container = _resolveComponent("ot-module-container")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_ot_module_container, { "scroll-settings": { suppressScrollX: false, suppressScrollY: false } }, {
    "main-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.$t('modules.accountOverview.header.marginLevel')) + " ", 1),
              (account.value?.name)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(account.value?.name), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.$t('modules.accountOverview.header.marginRatio')) + " ", 1),
                _withDirectives(_createVNode(_component_ot_icon, {
                  class: "account-overview__info-icon",
                  name: "info-circle"
                }, null, 512), [
                  [_directive_tooltip, 
                    getTooltip({
                      message: Object.entries(_unref(ACCOUNT_RATIO_STATUS_THRESHOLD_LABELS))
                        .map(
                          ([status, thresholdLabel]) => `
                        <div>
                          <span class='account-overview__margin-ratio--${status.toLowerCase()}'>${thresholdLabel}</span>
                          - ${_unref(t)(`fundamentals.accountRatio.status.${status}`)}
                        </div>
                      `,
                        )
                        .join(''),
                      html: true,
                    })
                  ]
                ]),
                (accountData.value.marginRatioStatus === _unref(AccountRatioStatus).DERISK || accountData.value.marginRatioStatus === _unref(AccountRatioStatus).LIQUIDATION)
                  ? (_openBlock(), _createBlock(_component_ot_lozenge, {
                      key: 0,
                      class: _normalizeClass(["account-overview__margin-ratio-lozenge", `account-overview__margin-ratio-lozenge--${accountData.value.marginRatioStatus?.toLowerCase()}`]),
                      filled: false,
                      text: _unref(t)(`fundamentals.accountRatio.status.${accountData.value.marginRatioStatus}`),
                      uppercase: ""
                    }, null, 8, ["class", "text"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(["account-overview__value", accountData.value.marginRatio !== '-' && `account-overview__margin-ratio--${accountData.value.marginRatioStatus?.toLowerCase()}`])
              }, _toDisplayString(accountData.value.marginRatio), 3)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('modules.accountOverview.header.maintenanceMargin')), 1),
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_ot_number_display, {
                  number: accountData.value.maintenanceMargin,
                  precision: 2,
                  "display-style": "currency",
                  "currency-display": "symbol",
                  grouping: true
                }, null, 8, ["number"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('fundamentals.leverage')), 1),
              _createElementVNode("span", _hoisted_13, _toDisplayString(accountData.value.leverage), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('modules.accountOverview.header.positionValue')), 1),
              _createElementVNode("span", _hoisted_16, [
                _createVNode(_component_ot_number_display, {
                  number: accountData.value.positionValue,
                  precision: 2,
                  "display-style": "currency",
                  "currency-display": "symbol",
                  grouping: true
                }, null, 8, ["number"])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_17, [
            _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.$t('modules.accountOverview.header.assets')), 1),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('modules.accountOverview.header.equity')), 1),
              _createElementVNode("span", _hoisted_21, [
                _createVNode(_component_ot_number_display, {
                  number: accountData.value.equity,
                  precision: 2,
                  "display-style": "currency",
                  "currency-display": "symbol",
                  grouping: true
                }, null, 8, ["number"])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('modules.accountOverview.header.availableMargin')), 1),
              _createElementVNode("span", _hoisted_24, [
                _createVNode(_component_ot_number_display, {
                  number: accountData.value.availableMargin,
                  precision: 2,
                  "display-style": "currency",
                  "currency-display": "symbol",
                  grouping: true
                }, null, 8, ["number"])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('modules.accountOverview.header.usedMargin')), 1),
              _createElementVNode("span", _hoisted_27, [
                _createVNode(_component_ot_number_display, {
                  number: accountData.value.lockedMargin,
                  precision: 2,
                  "display-style": "currency",
                  "currency-display": "symbol",
                  grouping: true
                }, null, 8, ["number"])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('modules.accountOverview.header.realisedPnl')), 1),
              _createElementVNode("span", _hoisted_30, [
                _createVNode(_component_ot_number_display, {
                  number: accountData.value.realisedPnL,
                  precision: 2,
                  "display-style": "currency",
                  "currency-display": "symbol",
                  grouping: true,
                  class: _normalizeClass({
                    'account-overview__profit--positive': accountData.value.realisedPnL > 0,
                    'account-overview__profit--negative': accountData.value.realisedPnL < 0,
                  })
                }, null, 8, ["number", "class"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})